module.exports = "/_next/static/festival-korw.css?21LW7di";